import Vue from 'vue';
import api from '../bu/api';

export default {
    namespaced: true,
    state: {
        entityMap: {},
    },
    getters: {
        entities: state => Object.values(state.entityMap).sort((a, b) => a.id - b.id)
    },
    mutations: {
        SET_ENTITIES(state, entities) {
            const entityMap = {};
            entities.forEach(entity => {
                entityMap[entity.id] = entity;
            });
            state.entityMap = entityMap;
        },
        UPDATE_ENTITY(state, entity) {
            if (state.entityMap[entity.id]) {
                Vue.set(state.entityMap, entity.id, entity);
            }
        },
        DELETE_ENTITY(state, entityId) {
            Vue.delete(state.entityMap, entityId);
        }
    },
    actions: {
        async fetchEntities({ commit }) {
            const response = await api.fetchGoogleReserveEntities();
            response.data.forEach(entity =>{
                if (typeof entity.location === 'string') {
                    entity.location = JSON.parse(entity.location);
                }
            });
            commit('SET_ENTITIES', response.data);
        },
        async saveEntity({ commit }, entity) {
            await api.saveProviderGoogleReserveEntities(entity);
            commit('UPDATE_ENTITY', entity);
        },
        async deleteEntity({ commit }, entityId) {
            await api.deleteGoogleReserveEntities(entityId);
            commit('DELETE_ENTITY', entityId);
        }
    }
}
